function getConsentStatus () {
  if (!window.Shopify?.customerPrivacy?.currentVisitorConsent) {
    console.error('Shopify.customerPrivacy.currentVisitorConsent not available - cannot get consent status')
    return
  }

  const { analytics, marketing, preferences } = window.Shopify.customerPrivacy.currentVisitorConsent()

  return {
    ad_user_data: marketing === 'yes' ? 'granted' : 'denied',
    ad_storage: marketing === 'yes' ? 'granted' : 'denied',
    ad_personalization: marketing === 'yes' ? 'granted' : 'denied',
    analytics_storage: analytics === 'yes' ? 'granted' : 'denied',
    functionality_storage: preferences === 'yes' ? 'granted' : 'denied',
    personalization_storage: marketing === 'yes' ? 'granted' : 'denied',
    security_storage: 'granted',
  }
}

function updateConsent (consentType, consentValues) {
  window.dataLayer = window.dataLayer || []

  window.dataLayer.push(['consent', consentType, consentValues])

  const isUpdate = consentType === 'update'
  const hasGrantedConsent = Object.values(consentValues).includes('granted')

  if (isUpdate && hasGrantedConsent) {
    window.dataLayer.push({
      event: 'consent_granted',
      categories: {
        ...consentValues,
      },
      timestamp: new Date().toISOString(),
    })
  }
}

function handleConsentUpdate (type) {
  const consentValues = getConsentStatus()
  updateConsent(type, consentValues)
}

// Load Shopify's consent-tracking API and set default consent
window.Shopify.loadFeatures(
  [{ name: 'consent-tracking-api', version: '0.1' }],
  (error) => {
    if (error) {
      console.error('Error loading Shopify consent API:', error)
      return
    }

    handleConsentUpdate('default')

    document.addEventListener('visitorConsentCollected', () => {
      handleConsentUpdate('update')
    })
  },
)
